import { useTheme } from 'styled-components'

import type { DefaultProps } from './DefaultProps'
import { Wrapper } from './Wrapper'

export const HeaderIconNotFound = ({ title, ...rest }: DefaultProps) => {
	const theme = useTheme() as any

	return (
		<Wrapper {...rest}>
			<svg viewBox='0 0 512 512' fill='none' xmlns='http://www.w3.org/2000/svg'>
				<path
					d='M418.32 2.50001C362.654 -7.02099 240.022 14.683 218.316 107.516C203.884 169.238 204.309 219.591 167.889 220.536C146.219 221.098 134.919 176.226 105 172.535C65.9528 167.718 38.8548 200.23 21.9428 229.673C-15.2622 294.445 -3.62815 404.591 45.2968 458.305C163.785 588.391 304.494 452.353 364.655 345.996C403.24 277.783 490.292 222.644 508.422 145.748C523.599 81.373 489.919 14.746 418.32 2.50001V2.50001Z'
					fill='url(#paint0_linear_26:688)'
				/>
				<path
					opacity='0.1'
					d='M455.47 452.133H56.5298C48.2458 452.133 41.5298 445.417 41.5298 437.133V122.867C41.5298 114.583 48.2458 107.867 56.5298 107.867H455.47C463.754 107.867 470.47 114.583 470.47 122.867V437.133C470.47 445.418 463.755 452.133 455.47 452.133Z'
					fill={theme.color.primary}
				/>
				<path
					d='M455.47 428.133H56.5298C48.2458 428.133 41.5298 421.417 41.5298 413.133V98.867C41.5298 90.583 48.2458 83.867 56.5298 83.867H455.47C463.754 83.867 470.47 90.583 470.47 98.867V413.133C470.47 421.418 463.755 428.133 455.47 428.133Z'
					fill={theme.color.cardBackground}
				/>
				<path
					d='M470.47 351.37V413.13C470.47 421.42 463.75 428.13 455.47 428.13H56.5298C48.2498 428.13 41.5298 421.42 41.5298 413.13V351.37H470.47Z'
					fill={theme.color.focus}
				/>
				<path
					d='M156.18 351.37L79.4198 428.13H56.5298C48.2498 428.13 41.5298 421.42 41.5298 413.13V397.88L88.0398 351.37H156.18Z'
					fill={theme.color.cardBackground}
				/>
				<path d='M294.71 351.37L217.95 428.13H149.81L226.56 351.37H294.71Z' fill={theme.color.cardBackground} />
				<path d='M433.23 351.37L356.47 428.13H288.34L365.09 351.37H433.23Z' fill={theme.color.cardBackground} />
				<path
					d='M470.47 384.24V413.13C470.47 421.42 463.75 428.13 455.47 428.13H426.58L470.47 384.24Z'
					fill={theme.color.cardBackground}
				/>
				<path
					d='M470.47 153.18V98.867C470.47 90.583 463.754 83.867 455.47 83.867H56.5298C48.2458 83.867 41.5298 90.583 41.5298 98.867V153.18H470.47Z'
					fill={theme.color.focus}
				/>
				<path
					d='M455.47 433.133H56.5298C45.5018 433.133 36.5298 424.161 36.5298 413.133V98.867C36.5298 87.839 45.5018 78.867 56.5298 78.867H455.47C466.498 78.867 475.47 87.839 475.47 98.867V413.133C475.47 424.161 466.498 433.133 455.47 433.133ZM56.5298 88.867C51.0158 88.867 46.5298 93.353 46.5298 98.867V413.133C46.5298 418.647 51.0158 423.133 56.5298 423.133H455.47C460.984 423.133 465.47 418.647 465.47 413.133V98.867C465.47 93.353 460.984 88.867 455.47 88.867H56.5298Z'
					fill={theme.color.primary}
				/>
				<path
					d='M85.6227 131.669C91.6431 131.669 96.5237 126.788 96.5237 120.768C96.5237 114.748 91.6431 109.867 85.6227 109.867C79.6022 109.867 74.7217 114.748 74.7217 120.768C74.7217 126.788 79.6022 131.669 85.6227 131.669Z'
					fill={theme.color.cardBackground}
				/>
				<path
					d='M120.423 131.669C126.444 131.669 131.324 126.788 131.324 120.768C131.324 114.748 126.444 109.867 120.423 109.867C114.403 109.867 109.522 114.748 109.522 120.768C109.522 126.788 114.403 131.669 120.423 131.669Z'
					fill={theme.color.cardBackground}
				/>
				<path
					d='M155.224 131.669C161.244 131.669 166.125 126.788 166.125 120.768C166.125 114.748 161.244 109.867 155.224 109.867C149.203 109.867 144.323 114.748 144.323 120.768C144.323 126.788 149.203 131.669 155.224 131.669Z'
					fill={theme.color.cardBackground}
				/>
				<path
					d='M432.278 133.015H296.119V108.52H432.278C435.039 108.52 437.278 110.759 437.278 113.52V128.016C437.278 130.777 435.039 133.015 432.278 133.015Z'
					fill={theme.color.cardBackground}
				/>
				<path
					d='M296.789 108.831C291.503 103.545 282.902 103.545 277.616 108.831C272.33 114.117 272.33 122.718 277.616 128.004C281.653 132.041 287.619 132.984 292.569 130.856L296.917 135.204C298.87 137.156 302.036 137.156 303.988 135.204C305.94 133.252 305.94 130.085 303.988 128.133L299.64 123.785C301.769 118.834 300.826 112.868 296.789 108.831V108.831ZM284.687 115.902C286.074 114.515 288.331 114.515 289.718 115.902C291.105 117.289 291.105 119.546 289.718 120.933C288.331 122.32 286.074 122.32 284.687 120.933C283.3 119.546 283.3 117.289 284.687 115.902Z'
					fill={theme.color.primary}
				/>
				<path
					d='M151.596 249.472H149.453V229.241C149.453 223.718 144.976 219.241 139.453 219.241C133.93 219.241 129.453 223.718 129.453 229.241V249.472H110.676L133.342 198.125C135.572 193.073 133.284 187.169 128.232 184.939C123.182 182.709 117.275 184.997 115.045 190.049L86.182 255.434C84.817 258.526 85.107 262.1 86.953 264.932C88.799 267.764 91.951 269.472 95.331 269.472H129.454V311.788C129.454 317.311 133.931 321.788 139.454 321.788C144.977 321.788 149.454 317.311 149.454 311.788V269.472H151.597C157.12 269.472 161.597 264.995 161.597 259.472C161.596 253.949 157.119 249.472 151.596 249.472V249.472Z'
					fill={theme.color.focus}
				/>
				<path
					d='M327.258 249.472H325.115V229.241C325.115 223.718 320.638 219.241 315.115 219.241C309.592 219.241 305.115 223.718 305.115 229.241V249.472H286.338L309.004 198.125C311.234 193.073 308.946 187.169 303.894 184.939C298.843 182.709 292.937 184.997 290.707 190.049L261.844 255.434C260.479 258.526 260.769 262.1 262.615 264.932C264.461 267.764 267.613 269.472 270.993 269.472H305.115V311.788C305.115 317.311 309.592 321.788 315.115 321.788C320.638 321.788 325.115 317.311 325.115 311.788V269.472H327.258C332.781 269.472 337.258 264.995 337.258 259.472C337.258 253.949 332.781 249.472 327.258 249.472V249.472Z'
					fill={theme.color.focus}
				/>
				<path
					d='M226.986 184.087H195.602C183.228 184.087 173.162 194.154 173.162 206.528V299.349C173.162 311.723 183.229 321.789 195.602 321.789H226.986C239.36 321.789 249.427 311.722 249.427 299.349V206.528C249.427 194.153 239.36 184.087 226.986 184.087ZM229.427 299.348C229.427 300.694 228.332 301.788 226.986 301.788H195.602C194.256 301.788 193.162 300.693 193.162 299.348V206.527C193.162 205.181 194.257 204.086 195.602 204.086H226.986C228.332 204.086 229.427 205.181 229.427 206.527V299.348Z'
					fill={theme.color.focus}
				/>
				<path
					d='M422.027 252.571H362.763C360.002 252.571 357.763 250.332 357.763 247.571V237.769C357.763 235.008 360.002 232.769 362.763 232.769H422.027C424.788 232.769 427.027 235.008 427.027 237.769V247.571C427.027 250.332 424.788 252.571 422.027 252.571Z'
					fill={theme.color.focus}
				/>
				<path
					d='M413.444 280.739H362.763C360.002 280.739 357.763 278.5 357.763 275.739C357.763 272.978 360.002 270.739 362.763 270.739H413.444C416.205 270.739 418.444 272.978 418.444 275.739C418.444 278.5 416.205 280.739 413.444 280.739Z'
					fill={theme.color.primary}
				/>
				<path
					d='M413.444 298.196H362.763C360.002 298.196 357.763 295.957 357.763 293.196C357.763 290.435 360.002 288.196 362.763 288.196H413.444C416.205 288.196 418.444 290.435 418.444 293.196C418.444 295.957 416.205 298.196 413.444 298.196Z'
					fill={theme.color.primary}
				/>
				<path
					d='M249.427 64.162C241.547 64.162 235.135 57.751 235.135 49.87C235.135 41.99 241.546 35.579 249.427 35.579C257.307 35.579 263.719 41.99 263.719 49.87C263.718 57.751 257.307 64.162 249.427 64.162ZM249.427 45.579C247.061 45.579 245.135 47.504 245.135 49.87C245.135 52.236 247.06 54.162 249.427 54.162C251.793 54.162 253.719 52.236 253.719 49.87C253.719 47.504 251.793 45.579 249.427 45.579Z'
					fill={theme.color.focus}
				/>
				<path
					d='M201.036 64.162C193.156 64.162 186.744 57.751 186.744 49.87C186.744 41.99 193.155 35.579 201.036 35.579C208.916 35.579 215.328 41.99 215.328 49.87C215.328 57.751 208.917 64.162 201.036 64.162ZM201.036 45.579C198.67 45.579 196.744 47.504 196.744 49.87C196.744 52.236 198.669 54.162 201.036 54.162C203.403 54.162 205.328 52.236 205.328 49.87C205.328 47.504 203.402 45.579 201.036 45.579Z'
					fill={theme.color.focus}
				/>
				<path
					d='M448.524 478.421C445.763 478.421 443.524 476.183 443.524 473.421C443.524 470.112 440.833 467.421 437.524 467.421C434.763 467.421 432.524 465.183 432.524 462.421C432.524 459.659 434.763 457.421 437.524 457.421C440.833 457.421 443.524 454.73 443.524 451.421C443.524 448.659 445.763 446.421 448.524 446.421C451.285 446.421 453.524 448.659 453.524 451.421C453.524 454.73 456.215 457.421 459.524 457.421C462.285 457.421 464.524 459.659 464.524 462.421C464.524 465.183 462.285 467.421 459.524 467.421C456.215 467.421 453.524 470.112 453.524 473.421C453.524 476.183 451.285 478.421 448.524 478.421Z'
					fill={theme.color.focus}
				/>
				<path
					d='M454.319 65.87C451.558 65.87 449.319 63.632 449.319 60.87C449.319 57.561 446.628 54.87 443.319 54.87C440.558 54.87 438.319 52.632 438.319 49.87C438.319 47.108 440.558 44.87 443.319 44.87C446.628 44.87 449.319 42.179 449.319 38.87C449.319 36.108 451.558 33.87 454.319 33.87C457.08 33.87 459.319 36.108 459.319 38.87C459.319 42.179 462.01 44.87 465.319 44.87C468.08 44.87 470.319 47.108 470.319 49.87C470.319 52.632 468.08 54.87 465.319 54.87C462.01 54.87 459.319 57.561 459.319 60.87C459.319 63.632 457.081 65.87 454.319 65.87Z'
					fill={theme.color.focus}
				/>
				<path
					d='M63.7227 478.421C60.9617 478.421 58.7227 476.183 58.7227 473.421C58.7227 470.112 56.0307 467.421 52.7227 467.421C49.9617 467.421 47.7227 465.183 47.7227 462.421C47.7227 459.659 49.9617 457.421 52.7227 457.421C56.0307 457.421 58.7227 454.73 58.7227 451.421C58.7227 448.659 60.9617 446.421 63.7227 446.421C66.4837 446.421 68.7227 448.659 68.7227 451.421C68.7227 454.73 71.4137 457.421 74.7227 457.421C77.4837 457.421 79.7227 459.659 79.7227 462.421C79.7227 465.183 77.4837 467.421 74.7227 467.421C71.4137 467.421 68.7227 470.112 68.7227 473.421C68.7227 476.183 66.4837 478.421 63.7227 478.421Z'
					fill={theme.color.focus}
				/>
				<path
					d='M470.47 356.37H41.5298C38.7688 356.37 36.5298 354.132 36.5298 351.37C36.5298 348.608 38.7688 346.37 41.5298 346.37H470.47C473.231 346.37 475.47 348.608 475.47 351.37C475.47 354.132 473.231 356.37 470.47 356.37Z'
					fill={theme.color.primary}
				/>
				<defs>
					<linearGradient
						id='paint0_linear_26:688'
						x1='37.4405'
						y1='125.854'
						x2='557.765'
						y2='338.876'
						gradientUnits='userSpaceOnUse'
					>
						<stop stopColor={theme.color.iconGradientStart} stopOpacity='0' />
						<stop offset='1' stopColor={theme.color.iconGradientStop} />
					</linearGradient>
				</defs>
				<title>{title ?? 'Not found'}</title>
			</svg>
		</Wrapper>
	)
}
